import { render } from "./DashboardArmazenagemTotal.vue?vue&type=template&id=64118076&scoped=true"
import script from "./DashboardArmazenagemTotal.vue?vue&type=script&lang=js"
export * from "./DashboardArmazenagemTotal.vue?vue&type=script&lang=js"

import "./DashboardArmazenagemTotal.vue?vue&type=style&index=0&id=64118076&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64118076"]])

export default __exports__